import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ModalComponent from '../../components/ModalComponent';

const PaymentRequiredPage = () => {
  const Navigate = useNavigate();
  const [showIncompletePaymentModal, setShowIncompletePaymentModal] = useState(true);

  const handleIncompletePaymentModal = () => {
    setShowIncompletePaymentModal(!showIncompletePaymentModal);
    Navigate('/my-account/plans');
  };

  return (
    <div>
      <ModalComponent
        title="Subscription verification"
        body={(
          <div>
            <div>Your subscription has expired.</div>
          </div>
        )}
        centered
        animation={false}
        show={showIncompletePaymentModal}
        onConfirm={handleIncompletePaymentModal}
        closeModal={handleIncompletePaymentModal}
        cancelButtonText="Go to plan change"
        hideConfirmButton
      />
    </div>
  );
};

export default PaymentRequiredPage;
